<script>
export default{

}
</script>
<style lang="sass">
    @import "../../common/styles/settings"

    .page-login

        &__logo
            height: 100px
            padding: 1rem
            box-sizing: border-box

        #block-antargaz-content
            width: 100%
            height: 100vh
            display: flex
            align-items: center
            justify-content: center
            flex-direction: column

        form
            &:before
                content: ''
                position: absolute
                width: 200px
                height: 100px
                background: url(../../common/assets/logo-antargaz.svg)
                background-size: contain
                background-repeat: no-repeat
                left: calc(50% - 100px)
                top: -100px

            position: relative
            background: #FAFAFA
            padding: 2rem
            border: 1px solid lightgrey
            box-shadow: 0 0 0.5rem 0.25rem rgba(0,0,0,0.05)

        .description
            padding: 0.5rem 0
            font-size: 0.875em
            letter-spacing: 0.05em
            color: darkgray
            margin-bottom: 2rem

        label
            display: block
            margin: 0 0 0.5em 0
            text-transform: uppercase
            letter-spacing: 0.025em

        input.form-text
            border: 1px solid gray
            padding: 0.875em 1em 0.75em
            background: lightgrey

        .form-submit
            padding: 1.25em 1.5em
            text-transform: uppercase
            letter-spacing: 0.05em
            border: none
            background: linear-gradient(to right, $color-base 0%, darken($color-base, 10%) 100%)
            color: white
            &:hover
                color: white


</style>
